import { MediaSplitLayout } from "@/components/media-split-layout";
import type { ModuleSplitLayoutFieldsFragment } from "@/lib/contentful/__generated/graphql.types";

export type ModuleSplitLayoutProps = ModuleSplitLayoutFieldsFragment;

const ModuleSplitLayout = (props: ModuleSplitLayoutProps) => {
    return <MediaSplitLayout {...props} />;
};

export { ModuleSplitLayout };
